import type { Workspace, WorkspaceType } from '@/types/workspaces'
import { useDashboardApiClient } from '../useDashboardApiClient'
import { DASHBOARD_ENDPOINTS } from '@/consts/api'

export const getWorkspaces = (urlParams: {
    workspaceType: WorkspaceType
}) => {
    return useDashboardApiClient<Workspace[]>({
        url: DASHBOARD_ENDPOINTS.WORKSPACES,
        urlParams,
    })
}

export type PostWorkspaceBodyData = {
    name: string
    workspaceType: Uppercase<WorkspaceType>
}

export const postWorkspace = (urlParams: {
    workspaceType: WorkspaceType
}, data: PostWorkspaceBodyData) => {
    return useDashboardApiClient<Workspace>({
        url: DASHBOARD_ENDPOINTS.WORKSPACES,
        urlParams,
        method: 'POST',
        data,
    })
}


export const deleteWorkspace = (urlParams: {
    workspaceType: WorkspaceType
    workspaceId: string
}) => {
    return useDashboardApiClient<Workspace>({
        url: DASHBOARD_ENDPOINTS.WORKSPACE_ID,
        urlParams,
        method: 'DELETE',
    })
}
